export default __webpack_public_path__ + "static/media/simple-swaps.d066533a.png";